export default function ServiceHighlight() {
  return (
    <section className="w-full py-20 bg-white">
      <div className="max-w-6xl mx-auto text-center px-4" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-[#1A1F2B]">Weekly Services</h2>
        <p className="text-gray-700 mt-3">
          A time of worship, teaching, prayer, and fellowship for all
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-14">
          <div className="p-8 border border-[#D2CBC3] rounded-xl shadow-sm">
            <h3 className="text-xl font-semibold text-[#1A1F2B]">
              Sunday Worship Service
            </h3>
            <p className="text-gray-600 mt-2">
              A gathering of believers for worship, teaching, prayer, and
              fellowship
              <br />
            </p>
          </div>

          <div className="p-8 border border-[#D2CBC3] rounded-xl shadow-sm">
            <h3 className="text-xl font-semibold text-[#1A1F2B]">
              Youth Ministry
            </h3>
            <p className="text-gray-600 mt-2">
              Discipleship, mentorship, and fellowship for young people
              <br />
            </p>
          </div>

          <div className="p-8 border border-[#D2CBC3] rounded-xl shadow-sm">
            <h3 className="text-xl font-semibold text-[#1A1F2B]">
              Prayer Ministry
            </h3>
            <p className="text-gray-600 mt-2">
              Corporate prayer, intercession, and spiritual encouragement
              <br />
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
